import { tinyDate } from '../../../services/sites/calendarService'
import i18next from 'i18next'

export const percentageTemplateFormBlock = {
  render: () => (
    `<div class='dhx_percentage_completed_slider'>
      <input type="range" min="0" max="100" step="1" id="percentage_completed_slider" style="padding: 0;" />
      <span id="percentage_completed_value"></span>
    </div>`
  ),
  set_value: function(node, value, _ev) {
    console.log('set_value', node, value, _ev)
    var slider = node.querySelector('#percentage_completed_slider')
    var display = node.querySelector('#percentage_completed_value')
    slider.value = value || 0
    display.innerHTML = slider.value

    slider.oninput = function() {
      display.innerHTML = this.value
    }
  },
  get_value: function(node, ev) {
    return node.querySelector('#percentage_completed_slider').value
  },
  focus: function(node) {
    node.querySelector('#percentage_completed_slider').focus()
  }
}

const getStatuses = () => ({
  draft: i18next.t('enumerations.site_status.draft'),
  estimate: i18next.t('enumerations.site_status.estimate'),
  approved: i18next.t('enumerations.site_status.approved'),
  under_construction: i18next.t('enumerations.site_status.under_construction'),
  delivered: i18next.t('enumerations.site_status.delivered'),
  closed: i18next.t('enumerations.site_status.closed'),
  unknown: i18next.t('enumerations.site_status.unknown'),
})

const statusBadge = (status) => {
  const statuses = getStatuses()
  const color = (() => {
    switch (status) {
      case 'draft': return '#6c757d' // Gray
      case 'estimate': return '#0d6efd' // Blue
      case 'approved': return '#198754' // Green
      case 'under_construction': return '#ffc107' // Yellow
      case 'delivered': return '#0dcaf0' // Cyan
      case 'closed': return '#dc3545' // Red
      default: return '#adb5bd' // Light gray
    }
  })()

  return `<span
    title="${statuses[status] || statuses.unknown}"
    style="display:inline-block;width:5px;height:5px;border-radius:50%;background-color:${color};margin-right:4px;"></span>`
}

export const renderSites = (data) => {
  return data.map(project => `
    <div class="mb-3">
      <button class="btn btn-outline-secondary btn-sm w-100 text-start d-flex justify-content-between align-items-center p-2 py-1"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#${project.id}"
        data-collapse-toggle
        data-collapse-level-1
        aria-expanded="${project.expanded}">
        <small class="d-flex flex-column text-truncate">
          <span class="fw-bold">${project.name}</span>
          ${project.sites?.length ? `<i>${statusBadge(project.sites[0].status)} ${project.sites[0].revision_title}</i>` : ''}
        </small>
        <i class="bi ${project.expanded ? 'bi-chevron-down' : 'bi-chevron-right'}" data-collapse-chevron></i>
      </button>
      <div class="collapse ${project.expanded ? 'show' : ''}" id="${project.id}">
        ${project.categories.map(cat => `
          <div class="ms-2 mt-2">
            <button class="btn btn-light btn-sm w-100 text-start d-flex justify-content-between align-items-center py-1 px-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#${cat.id}"
              data-collapse-toggle
              data-collapse-level-2
              aria-expanded="${cat.expanded}">
              <small class="text-muted">${cat.name}</small>
              <i class="bi ${cat.expanded ? 'bi-chevron-down' : 'bi-chevron-right'}" data-collapse-chevron style="font-size:.8rem"></i>
            </button>
            <div class="collapse ${cat.expanded ? 'show' : ''}" id="${cat.id}">
              <div>
                <div class="list-group list-group-flush">
                  ${cat.tasks.map(task => `
                    <button
                      data-site-task-id="${task.id}"
                      data-draggable-event
                      draggable="true"
                      class="list-group-item list-group-item-action border-0 bg-transparent d-flex align-items-start px-2 py-1 gap-2 hover-bg-secondary cursor-grab">
                      <span class="text-nowrap text-end flex-shrink-0 fs-7 mt-1" style="width: 2rem;">${tinyDate(task.start_date)}</span>
                      <span class="flex-grow-1 text-decoration-underline multiline-truncate-2" style="min-width: 0; max-width: 100%; word-break: break-all;">${task.title}</span>
                    </button>
                  `).join('')}
                </div>
              </div>
            </div>
          </div>
        `).join('')}
      </div>
    </div>
  `).join('')
}
